const initialState = {
    filtersChecked: {},
    pathName: "",
    cycleData: {},
    totalEmployee: 0
}

const managerDashboard = (state = initialState, action) => {
    switch (action.type) {
        case "SET_FILTERS_DASHBOARD_MANAGER":
            state = {
                ...state,
                filtersChecked: action.payload
            }
            return state
        case "SET_PATHNAME_DASHBOARD_MANAGER":
            state = {
                ...state,
                pathName: action.payload
            }
            return state
        case "SET_CYCLE_DASHBOARD_MANAGER":
            state = {
                ...state,
                cycleData: action.payload
            }
            return state
        case "SET_TOTAL_EMPLOYEE_DASHBOARD_MANAGER":
            state = {
                ...state,
                totalEmployee: action.payload
            }
            return state
        default:
            return state
    }
}

export default managerDashboard
